import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {getParam} from "../../components/Utils/Utils";

async function getNoticeList(search, pageable) {
    try {
        console.log(await needAuth.post(`/notice?${getParam(pageable)}`, search))
        return await needAuth.post(`/notice?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            return {status: error.response.status, data: error.response.data};
        }
        throw error;
    }
}

async function getNotice(id) {
    return await needAuth.get('/notice/' + id);
}

async function removeNotices(ids) {
    return await needAuth.put('/notice/delete', ids);
}

async function saveNotice(data, files) {
    const formData = new FormData();
    files.forEach((file) => {
        formData.append('files', file);
    });

    formData.append(
        "noticeRequestDto",
        new Blob([JSON.stringify(data)], {type: "application/json"}),
    );
    return await needAuth.post(
        '/notice/create',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        },
    );
}

async function updateNotice(notice) {
    const data = {id: notice.id, fieldName: "subject", value: notice.subject};
    await needAuth.put(`/notice`, data);
    const data2 = {id: notice.id, fieldName: "content", value: notice.content};
    return await needAuth.put(`/notice`, data2);
}

export {getNoticeList, saveNotice, updateNotice, removeNotices, getNotice};
